<template>
<div>

    <v-layout row justify-center>
        <v-dialog v-model="loadingNotDone" persistent fullscreen content-class="loading-dialog" class="loading-dialog">
            <v-container text-xs-center mt-5>
                <v-layout row wrap justify-center align-center justify-space-between>
                    <v-flex xs12 my-3 white--text>
                        <span class="font-weight-light display-3">Fold</span>
                        <span class="font-weight-medium display-3">Plan</span>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs12>
                        <v-progress-circular indeterminate :size="40" :width="7" color="white"></v-progress-circular>
                    </v-flex>

                </v-layout>

            </v-container>
        </v-dialog>
    </v-layout>
</div>
</template>

<script>
import firebase from 'firebase/app'
export default {

    data() {
        return {

        }
    },
    computed: {
        loadingNotDone() {
            if (this.$store.getters.loadingDone)
                return false
            else
                return true //
        },
        loadingDone() {
            return this.$store.getters.loadingDone
        }

    },
    watch: {
        loadingDone: function () {
            this.$store.dispatch('setShowNavbar', true)

            if (firebase.auth().currentUser) {
                this.$router.push({
                    name: 'dashboard'
                })
                console.log('loadingDone, goto dashbaord')
            } else {
                this.$router.push({
                    name: 'login'
                })
                console.log('loadingDone, goto login')
            }

        }
    }

}
</script>

<style>
.loading-dialog {
    background-color: #1976d2;
}
</style>
